<script setup lang="ts">
import { Check } from '@lucide/vue'
import SiteEditableText from '../../SiteEditableText.vue'
import SiteLink from '../../SiteLink.vue'
import type { FeaturesBlock } from '../../types'

defineProps<{ block: FeaturesBlock }>()
</script>

<template>
  <section :id="block.settings.anchorId" class="site:bg-(--site-color-surface) site:py-16 site:@min-[40rem]:py-24">
    <div class="site-site-container">
      <div class="site:mx-auto site:max-w-3xl site:text-center">
        <SiteEditableText v-if="block.content.eyebrow" v-model="block.content.eyebrow" as="p" class="site:text-sm site:font-semibold site:text-(--site-color-primary)" />
        <SiteEditableText v-model="block.content.heading" as="h2" class="site-heading site:mt-3 site:text-3xl site:font-bold site:tracking-tight site:@min-[40rem]:text-5xl" />
        <SiteEditableText v-if="block.content.description" v-model="block.content.description" as="p" class="site:mx-auto site:mt-5 site:max-w-2xl site:text-lg site:leading-8 site:text-(--site-color-muted-text)" />
      </div>

      <div
        class="site:mt-12 site:grid site:gap-4"
        :class="block.settings.columns === 2 ? 'site:@min-[48rem]:grid-cols-2' : 'site:@min-[48rem]:grid-cols-2 site:@min-[64rem]:grid-cols-3'"
      >
        <article
          v-for="item in block.content.items"
          :key="item.id"
          class="site:border site:border-(--site-color-border) site:bg-(--site-color-background) site:p-6 site:shadow-(--site-shadow-sm) site:@min-[40rem]:p-8"
          :style="{ borderRadius: 'var(--site-radius-md)' }"
        >
          <span class="site:grid site:size-11 site:place-items-center site:rounded-full site:bg-(--site-color-accent) site:text-(--site-color-primary)">
            <Check :size="19" :stroke-width="2.2" aria-hidden="true" />
          </span>
          <SiteEditableText v-model="item.title" as="h3" class="site-heading site:mt-8 site:text-xl site:font-bold site:tracking-tight" />
          <SiteEditableText v-model="item.description" as="p" class="site:mt-3 site:leading-7 site:text-(--site-color-muted-text)" />
        </article>
      </div>

      <div v-if="block.content.action" class="site:mt-9 site:flex site:justify-center">
        <SiteLink :link="block.content.action" class="site-site-button">
          {{ block.content.action.label }}
        </SiteLink>
      </div>
    </div>
  </section>
</template>
